import { categoryConfig } from "./categoryConfig";
import "./CategoryList.css";

export default function CategoryList({
  categories,
  selectedCategory,
  onCategorySelect,
  itemProps = {},
}) {
  return (
    <div className="list-group list-group-flush category-list">
      {categories.map((cat) => {
        const config = categoryConfig[cat.name] || {};
        const isActive = selectedCategory === cat.id;

        return (
          <div
            key={cat.name}
            onClick={() => onCategorySelect(cat.id)}
            className={`list-group-item category-item d-flex justify-content-between align-items-center border-0 px-3 py-3 ${isActive ? "active-category" : ""}`}
            style={{ cursor: "pointer" }}
            {...itemProps}
          >
            {/* Left Side */}
            <div className="d-flex align-items-center gap-3">
              <div
                className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  backgroundColor: config.color + "15",
                  color: config.color,
                }}
              >
                {config.icon}
              </div>

              <span className="fw-medium category-name">{cat.name}</span>
            </div>

            {/* Count Badge  commented to be used for admins*/}
            {/* <span className="badge bg-light text-dark rounded-pill px-3 py-2 shadow-sm">
              {cat.productCount}
            </span> */}
          </div>
        );
      })}
    </div>
  );
}
